import { openNativeSettings } from "@src/appV2/lib/NativeSettings/native-settings";
import { CameraPermissionErrorBottomSheet } from "@src/appV2/redesign/components/CameraPermissionErrorBottomSheet";
import { type UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";

interface BadgeVerificationCameraPermissionSheetProps {
  modalState: UseModalState;
}

export function BadgeVerificationCameraPermissionSheet(
  props: BadgeVerificationCameraPermissionSheetProps
) {
  const { modalState } = props;
  const handleGoToSettings = useCallback(async () => {
    modalState.closeModal();
    await openNativeSettings({ option: "application_details" });
  }, [modalState]);

  return (
    <CameraPermissionErrorBottomSheet modalState={modalState} onGoToSettings={handleGoToSettings} />
  );
}
